module.exports = __webpack_public_path__ + "img/logo.df199801.svg";